import { UniInput } from '@/design-system/components/inputs/UniInput';
import { SxProp, View } from 'dripsy';
import React from 'react';

import { TextTitle } from '@/design-system/components/typography';

interface UniTabSearchProps {
  title: string;
  value?: string;
  defaultValue?: string;
  onValueChange?: (value: string | undefined) => void;
}

export const UniTabSearch: React.FC<UniTabSearchProps> = (props) => {
  const { title, value, onValueChange } = props;

  return (
    <View sx={styles.container}>
      <TextTitle semiBold sx={styles.title}>
        {title}
      </TextTitle>
      <View sx={styles.searchBox}>
        <UniInput size="small" value={value} onValueChange={onValueChange} prefixIcon="search" />
      </View>
    </View>
  );
};

const styles: Record<string, SxProp> = {
  container: {
    paddingX: 16,
    paddingY: 20,
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center'
  },
  title: {
    flex: 1
  },
  searchBox: {
    flex: 1
  }
};
